import { Loadable } from '..';
import { HashMap } from '../../constants';
import { LoadCommandStocksPayload } from '../payload/loadRequests';
import { Sim } from '../sim';
import { SimCommandCreate } from '../simCommand';

/**
 * The number of seconds the application will wait before refreshing Command Types from the server.
 */
export const CommandTypesStateCacheTimeout = 3600;

export interface CommandGroup {
  id: number;
  name: string;
  order: number;
  commandTypes: CommandType[];
}

export interface CommandTypesPayload {
  groups: CommandGroup[];
}

export interface CommandTypes extends CommandTypesPayload {
  /* Command types hash-map, indexed by json alias */
  allTypes: HashMap<CommandType>;
}

export interface CommandType {
  id: number;
  jsonAlias: string;
  name: string;
}

export type CommandTypesState = Loadable<CommandTypes>;

export const getDefaultCommandTypes = (): CommandTypes => {
  return {
    allTypes: {},
    groups: []
  };
};

/**
 * Gets default settings for command types state.
 */
export const getDefaultCommandTypesState = (): CommandTypesState => {
  return {
    ...getDefaultCommandTypes(),
    isLoading: false
  };
};

export interface UiCommandItem {
  backUrl?: string;
  type: string;
  label: string;
  id?: string;
}

export interface UiCommandGroup {
  id: number;
  name: string;
  items: UiCommandItem[];
}

export interface CommandTab {
  id: number;
  networkId?: number;
  tabName: string;
  sims: Sim[];
}

export interface CommandStocks {
  params: LoadCommandStocksPayload;
  value: HashMap<SimCommandCreate>;
}
